import { render } from "./application-menu.html?vue&type=template&id=4c12f6a1&scoped=true&ts=true&external"
import script from "./application-menu.ts?vue&type=script&lang=ts&external"
export * from "./application-menu.ts?vue&type=script&lang=ts&external"

import "./application-menu.scss?vue&type=style&index=0&id=4c12f6a1&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c12f6a1"]])

export default __exports__